import { render, staticRenderFns } from "./BusinessModelElement.vue?vue&type=template&id=7a45f7ab&scoped=true&"
import script from "./BusinessModelElement.vue?vue&type=script&lang=js&"
export * from "./BusinessModelElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45f7ab",
  null
  
)

export default component.exports